import React, {useState} from 'react';
import {IDataRow, IDataRowTextField} from "../../../core/interfaces/document";
import ClickableIconButton from "../../../components/ClickableIconButton/ClickableIconButton";
import getIcon, {Icon, IconSize} from "../../../assets/Icons/IconClassNames";
import {useUpdateActionPlanDataRow} from "../../../api/ActionPlanApi";
import When from "../../../components/When";
import CustomTextInput from "../../../components/FormComponents/CustomTextInput";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {getDataRowHeader} from "../../../core/helpers/dataRowHelper";

interface IActionPlanDescription {
    isNew: boolean;
    dataRow: IDataRow;
    setDataRow: (dr: IDataRow) => void;
    actionPlanId?: string;
    createAsNew?: boolean;
}

const ActionPlanDescription = (
    {
        isNew,
        dataRow,
        setDataRow,
        actionPlanId,
        createAsNew,
    }: IActionPlanDescription) => {

    const [updateDataRow] = useUpdateActionPlanDataRow(actionPlanId ?? "");
    const [modifiedRow, setModifiedRow] = useState<IDataRow | undefined>(dataRow);
    const [editMode, setEditMode] = useState(isNew ? true : false);

    const updateActionPlanDescription = async () => {
        if (modifiedRow !== undefined) {
            const request = {...modifiedRow}
            if (createAsNew) {
                request.id = undefined;
            }
            await updateDataRow(request, createAsNew)
        }
        setEditMode(false)
    }

    const handleUpdate = (updatedRow: IDataRow) => {
        if (isNew) {
            setDataRow(updatedRow);
            setModifiedRow(updatedRow);
        } else {
            setModifiedRow({...updatedRow})
        }
    }

    const handleClose = () => {
        setEditMode(false)
        setModifiedRow({...dataRow})
    }

    const isNoChanges = () => {
        return JSON.stringify(modifiedRow) === JSON.stringify(dataRow);
    }

    const editButton = () => (
        <ClickableIconButton
            disabled={false}
            buttonType={"EDIT"}
            icon={getIcon(Icon.EDIT)}
            onClick={() => setEditMode(true)}
            title={"Redigera"}
        />
    );

    const saveCloseButtons = () => (
        <div className="d-flex align-content-end flex-row-reverse">
            <ClickableIconButton
                disabled={false}
                buttonType={"CANCEL"}
                icon={getIcon(Icon.X_MARK, IconSize.XL)}
                onClick={handleClose}
                title={"Avbryt redigering"}
            />
            <ClickableIconButton
                disabled={isNoChanges()}
                buttonType={"SAVE"}
                icon={getIcon(Icon.SAVE, IconSize.XL)}
                title={"Spara ändringar"}
                onClick={() => updateActionPlanDescription()}
            />
        </div>
    );

    const onChange = (e: any) => {
        let updated = {...modifiedRow} as IDataRowTextField;
        updated.textValue = e.target.value;
        handleUpdate(updated);
    }

    return (
        <When condition={dataRow !== null}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                {/*<When condition={!isNew}>*/}
                {/*    <div style={{*/}
                {/*        display: 'flex',*/}
                {/*        justifyContent: 'flex-end',*/}
                {/*        paddingRight: '20px',*/}
                {/*    }}>*/}
                {/*        <When condition={!editMode} otherwise={saveCloseButtons()}>*/}
                {/*            {editButton()}*/}
                {/*        </When>*/}
                {/*    </div>*/}
                {/*</When>*/}
                <Row className={"mt-3 mb-3 ms-2 me-2"}>

                    <Col md={3}>
                        <CustomTextInput
                            isEditMode={false}
                            disabled
                            name={"header"}
                            value={getDataRowHeader(dataRow)}
                            onChange={() => NaN}
                        />
                    </Col>
                    <Col md={9}>
                        <CustomTextInput
                            isEditMode={true}
                            disabled={false}
                            name={"textValue"}
                            value={modifiedRow?.textValue ?? ""}
                            onChange={onChange}
                            disableAutocomplete
                            type={"text"}
                            maxLength={30}
                        />
                    </Col>
                </Row>
            </div>
        </When>
    );
};

export default ActionPlanDescription;